var __dsT = function (k, d) { var o = window.dsI18n || {}; return (o[k] != null) ? o[k] : d; };
/* De Sierkamer — homepage interactivity (maatkiezer, sfeerkiezer, licht-toggle, reviews-slider).
   Guarded so the file can be included from multiple sections safely. */
(function () {
  'use strict';
  if (window.__dsHomeInit) return;
  window.__dsHomeInit = true;

  /* Licht aan/uit */
  class DsLichtToggle extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.ds-licht');
      this.btnText = this.querySelector('[data-ds-btn-text]');
      this.state = this.section && this.section.querySelector('[data-ds-state]');
      this.addEventListener('click', () => this.toggle());
    }
    toggle() {
      if (!this.section) return;
      const on = this.section.classList.toggle('is-on');
      if (this.btnText) this.btnText.textContent = on ? this.dataset.labelOff : this.dataset.labelOn;
      if (this.state) this.state.textContent = on ? this.dataset.stateOn : this.dataset.stateOff;
      this.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  if (!customElements.get('ds-licht-toggle')) customElements.define('ds-licht-toggle', DsLichtToggle);

  /* Maatkiezer */
  class DsMaatKiezer extends HTMLElement {
    connectedCallback() {
      try {
        this.maten = JSON.parse(this.querySelector('script[data-ds-maten]').textContent);
      } catch (e) { return; }
      this.slider = this.querySelector('input[type="range"]');
      this.opts = Array.from(this.querySelectorAll('.ds-maat__opt'));
      this.els = {};
      ['group', 'ftop', 'flegl', 'flegr', 'shade', 'stem', 'base', 'dimv', 'dimt', 'dimb',
        'meubel', 'hoogte', 'spec', 'titel', 'tekst'].forEach((k) => {
        this.els[k] = this.querySelector('[data-ds="' + k + '"]');
      });
      if (this.slider) {
        this.slider.addEventListener('input', () => this.update(parseInt(this.slider.value, 10)));
      }
      this.opts.forEach((btn, idx) => btn.addEventListener('click', () => {
        if (this.slider) this.slider.value = String(idx);
        this.update(idx);
      }));
      this.update(0);
    }
    update(i) {
      i = Math.max(0, Math.min(this.maten.length - 1, i || 0));
      const m = this.maten[i];
      const px = 1.05, floorY = 176, fx = 18;
      const fh = m.meubelCm * px;
      const fTopY = floorY - fh;
      const fw = Math.min(m.meubelBreedteCm * px, 138);
      const diaCm = parseInt(m.dia, 10);
      const shadeW = diaCm * px * 1.5;
      const lampH = m.hoogte * px;
      const shadeH = lampH * 0.32;
      const baseW = shadeW * 0.42;
      const stemH = lampH - shadeH - 7;
      const lampCx = fx + fw * 0.66;
      const lampTopY = fTopY - lampH;
      const sx1 = lampCx - shadeW * 0.34, sx2 = lampCx + shadeW * 0.34;
      const sx3 = lampCx + shadeW / 2, sx4 = lampCx - shadeW / 2;
      const shadeBottomY = lampTopY + shadeH;
      const dimX = fx + fw + 24;
      const shiftY = -Math.round(((75 + 66) * px - (m.meubelCm + m.hoogte) * px) / 2);

      const set = (el, attrs) => { if (el) for (const k in attrs) el.setAttribute(k, attrs[k]); };
      set(this.els.group, { transform: 'translate(0, ' + shiftY + ')' });
      set(this.els.ftop, { x: fx, y: fTopY, width: fw, height: 9 });
      set(this.els.flegl, { x: fx + 8, y: fTopY + 9, height: Math.max(0, fh - 9) });
      set(this.els.flegr, { x: fx + fw - 14, y: fTopY + 9, height: Math.max(0, fh - 9) });
      set(this.els.shade, { points: sx1 + ',' + lampTopY + ' ' + sx2 + ',' + lampTopY + ' ' + sx3 + ',' + shadeBottomY + ' ' + sx4 + ',' + shadeBottomY });
      set(this.els.stem, { x: lampCx - 2, y: shadeBottomY, height: Math.max(0, stemH) });
      set(this.els.base, { x: lampCx - baseW / 2, y: fTopY - 7, width: baseW });
      set(this.els.dimv, { x1: dimX, y1: lampTopY, x2: dimX, y2: fTopY });
      set(this.els.dimt, { x1: dimX - 4, y1: lampTopY, x2: dimX + 4, y2: lampTopY });
      set(this.els.dimb, { x1: dimX - 4, y1: fTopY, x2: dimX + 4, y2: fTopY });

      if (this.els.meubel) this.els.meubel.textContent = m.meubel;
      if (this.els.hoogte) this.els.hoogte.textContent = __dsT('maat_lamp_word', 'Lamp') + ' ' + m.hoogte + ' cm';
      if (this.els.spec) this.els.spec.textContent = '⌀' + m.dia + (m.dia === '40+' ? '' : ' cm') + ' · ' + m.hoogte + ' ' + __dsT('maat_high', 'cm hoog · vanaf') + ' ' + m.prijs;
      if (this.els.titel) this.els.titel.textContent = m.titel;
      if (this.els.tekst) this.els.tekst.textContent = m.tekst;
      this.opts.forEach((btn, idx) => btn.setAttribute('aria-pressed', idx === i ? 'true' : 'false'));
    }
  }
  if (!customElements.get('ds-maat-kiezer')) customElements.define('ds-maat-kiezer', DsMaatKiezer);

  /* Reviews slider */
  class DsReviewSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ds-reviews__track');
      this.slides = Array.from(this.querySelectorAll('.ds-reviews__slide'));
      this.prevBtn = this.querySelector('[data-ds-prev]');
      this.nextBtn = this.querySelector('[data-ds-next]');
      this.bar = this.querySelector('.ds-reviews__progress-bar');
      this.viewport = this.querySelector('.ds-reviews__viewport');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.index = 0;
      this.tick = 0;

      /* Mobiel: native scroll-snap-rij; de balk volgt de scrollpositie.
         Behalve op 'scroll' meten we ook na afloop van de beweging: tijdens het
         uitrollen valt het laatste scroll-event wel eens weg (iOS), en dan bleef
         de balk halverwege hangen in plaats van rechts uit te komen. */
      if (this.viewport) {
        const volg = () => this.volgScroll();
        this.viewport.addEventListener('scroll', () => {
          if (this.tick) return;
          this.tick = requestAnimationFrame(() => { this.tick = 0; volg(); });
        }, { passive: true });
        this.viewport.addEventListener('scrollend', volg);
        this.viewport.addEventListener('touchend', () => setTimeout(volg, 300), { passive: true });
        this.mobile.addEventListener('change', () => this.go(0));
      }
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      window.addEventListener('resize', this.debounce(() => this.go(this.index), 150));

      // swipe support
      let startX = null;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
      this.go(0);
    }
    visible() {
      const w = window.innerWidth;
      return w > 989 ? 3 : (w > 749 ? 2 : 1);
    }
    /* Mobiele balk: de breedte is de zichtbare fractie van de rij en de linkerkant
       loopt van 0 tot (100 - breedte). Links + breedte komt dus precies op 100%
       uit zodra er niet verder te scrollen valt. */
    volgScroll() {
      if (!this.viewport || !this.bar || !this.mobile.matches) return;
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      let p = max > 1 ? this.viewport.scrollLeft / max : 0;
      if (p > 0.995) p = 1;
      if (p < 0.005) p = 0;
      const breedte = Math.min(60, Math.max(18, (this.viewport.clientWidth / this.viewport.scrollWidth) * 100));
      this.bar.style.width = breedte + '%';
      this.bar.style.left = (p * (100 - breedte)) + '%';
    }
    go(i) {
      if (!this.track || !this.slides.length) return;
      if (this.mobile && this.mobile.matches) {
        this.track.style.transform = '';
        this.volgScroll();
        return;
      }
      const max = Math.max(0, this.slides.length - this.visible());
      this.index = Math.max(0, Math.min(max, i));
      const slide = this.slides[0];
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 34);
      const step = slide.getBoundingClientRect().width + gap;
      this.track.style.transform = 'translateX(' + (-this.index * step) + 'px)';
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.index === 0);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.index >= max);
      if (this.bar) {
        const segs = max + 1;
        this.bar.style.width = (100 / segs) + '%';
        this.bar.style.left = (this.index * (100 / segs)) + '%';
      }
    }
    debounce(fn, wait) {
      let t; return () => { clearTimeout(t); t = setTimeout(fn, wait); };
    }
  }
  if (!customElements.get('ds-review-slider')) customElements.define('ds-review-slider', DsReviewSlider);

  /* Sfeerkiezer — één regelaar met een doorlopende positie t (0..n-1).
     Slepen volgt de vinger 1-op-1; bij lossen glijdt t in 420 ms naar de
     dichtstbijzijnde stand. De greepkleur en de vier glastinten mengen
     onderweg, de teksten volgen de dichtstbijzijnde stand. */
  const dsHex = (h) => {
    h = String(h || '').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    const n = parseInt(h, 16);
    if (h.length !== 6 || isNaN(n)) return [0, 0, 0];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  };
  const dsMeng = (a, b, f) => {
    const x = dsHex(a), y = dsHex(b);
    return [0, 1, 2].map((i) => Math.round(x[i] + (y[i] - x[i]) * f));
  };

  class DsSfeerKiezer extends HTMLElement {
    connectedCallback() {
      try {
        this.sferen = JSON.parse(this.querySelector('script[data-ds-sferen]').textContent);
      } catch (e) { return; }
      if (!this.sferen.length) return;

      this.track = this.querySelector('[data-ds-track]');
      this.hit = this.querySelector('[data-ds-hit]');
      this.grip = this.querySelector('[data-ds-grip]');
      if (!this.track || !this.hit || !this.grip) return;

      this.links = Array.from(this.querySelectorAll('[data-ds-labels] a'));
      this.vlakken = Array.from(this.querySelectorAll('[data-ds-vlak]'));
      this.tintnamen = Array.from(this.querySelectorAll('[data-ds-tintnaam]'));
      this.naam = this.querySelector('[data-ds-naam]');
      this.regel = this.querySelector('[data-ds-regel]');
      this.aantal = this.querySelector('[data-ds-aantal]');
      this.cta = this.querySelector('[data-ds-cta]');

      this.last = this.sferen.length - 1;
      this.t = 0;
      this.dichtst = 0;
      this.slepen = false;
      this.raf = null;
      this.rect = null;
      this.aangeraakt = false;
      this.stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onMove = (e) => { if (!this.slepen) return; e.preventDefault(); this.uitX(e.clientX); };
      this.onUp = () => {
        if (!this.slepen) return;
        this.slepen = false;
        this.track.classList.remove('is-dragging');
        this.glij();
      };

      this.track.addEventListener('pointerdown', (e) => {
        this.aangeraakt = true;
        cancelAnimationFrame(this.raf);
        this.rect = this.track.getBoundingClientRect();
        try { this.track.setPointerCapture(e.pointerId); } catch (err) { /* niet kritiek */ }
        this.slepen = true;
        this.track.classList.add('is-dragging');
        this.uitX(e.clientX);
      });
      window.addEventListener('pointermove', this.onMove, { passive: false });
      window.addEventListener('pointerup', this.onUp);
      window.addEventListener('pointercancel', this.onUp);

      this.track.addEventListener('keydown', (e) => {
        const n = Math.round(this.t);
        if (e.key === 'ArrowRight' && n < this.last) { this.aangeraakt = true; this.glij(n + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft' && n > 0) { this.aangeraakt = true; this.glij(n - 1); e.preventDefault(); }
      });

      this.links.forEach((a, n) => a.addEventListener('click', (e) => {
        e.preventDefault();
        this.aangeraakt = true;
        this.glij(n);
      }));

      this.teken();
      if (this.dataset.hint === 'true' && !this.stil) this.wenk();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
      window.removeEventListener('pointercancel', this.onUp);
    }

    teken() {
      const lo = Math.max(0, Math.min(this.last, Math.floor(this.t)));
      const hi = Math.max(0, Math.min(this.last, Math.ceil(this.t)));
      const f = this.stil ? 0 : this.t - lo;
      const n = Math.max(0, Math.min(this.last, Math.round(this.t)));
      const a = this.sferen[lo], b = this.sferen[hi], m = this.sferen[n];

      this.hit.style.left = (this.last ? (this.t / this.last) * 100 : 50) + '%';

      const kleur = dsMeng(a.kleur, b.kleur, f).join(',');
      this.grip.style.borderColor = 'rgb(' + kleur + ')';
      this.grip.style.boxShadow = '0 0 ' + (this.slepen ? 16 : 9) + 'px 1px rgba(' + kleur + ',' + (this.slepen ? 0.5 : 0.28) + ')';

      this.vlakken.forEach((el, i) => {
        if (!a.tinten[i] || !b.tinten[i]) return;
        el.style.background = 'rgb(' + dsMeng(a.tinten[i].c, b.tinten[i].c, f).join(',') + ')';
      });
      const weg = Math.min(1, Math.abs(this.t - n) * 2);
      this.tintnamen.forEach((el, i) => {
        if (!m.tinten[i]) return;
        el.textContent = m.tinten[i].n;
        el.style.opacity = 1 - weg * 0.75;
      });

      if (this.naam) this.naam.textContent = m.naam;
      if (this.regel) this.regel.textContent = m.regel;
      if (this.aantal) this.aantal.textContent = m.aantal;
      if (this.cta) { this.cta.textContent = m.cta; this.cta.setAttribute('href', m.href); }

      this.track.setAttribute('aria-valuenow', n + 1);
      this.track.setAttribute('aria-valuetext', m.naam);
      this.links.forEach((el, i) => {
        el.style.opacity = 1 - Math.min(1, Math.abs(this.t - i)) * 0.6;
        if (i === n) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });

      if (n !== this.dichtst) {
        this.dichtst = n;
        if (navigator.vibrate && window.matchMedia('(max-width: 749px)').matches) navigator.vibrate(8);
      }
    }

    uitX(x) {
      if (!this.rect || !this.rect.width) return;
      const f = Math.max(0, Math.min(1, (x - this.rect.left) / this.rect.width));
      this.t = f * this.last;
      this.teken();
    }

    /* Glijdt in 420 ms naar een hele stand (ease-out cubic). */
    glij(naar) {
      cancelAnimationFrame(this.raf);
      if (naar === undefined) naar = Math.round(this.t);
      naar = Math.max(0, Math.min(this.last, naar));
      if (this.stil || Math.abs(naar - this.t) < 0.001) { this.t = naar; this.teken(); return; }
      const van = this.t, begin = performance.now();
      const stap = (nu) => {
        const p = Math.min(1, (nu - begin) / 420);
        this.t = van + (naar - van) * (1 - Math.pow(1 - p, 3));
        this.teken();
        if (p < 1) this.raf = requestAnimationFrame(stap);
      };
      this.raf = requestAnimationFrame(stap);
    }

    /* Eén zachte beweging heen en terug, zodat de greep zich aankondigt. */
    wenk() {
      const plan = () => window.setTimeout(() => {
        if (this.aangeraakt) return;
        const van = this.t, piek = Math.min(this.last, van + 0.22), begin = performance.now();
        const stap = (nu) => {
          if (this.aangeraakt) { this.t = van; this.teken(); return; }
          const p = Math.min(1, (nu - begin) / 1100);
          this.t = van + (piek - van) * Math.sin(p * Math.PI);
          this.teken();
          if (p < 1) this.raf = requestAnimationFrame(stap);
          else { this.t = van; this.teken(); }
        };
        this.raf = requestAnimationFrame(stap);
      }, 900);

      if (!('IntersectionObserver' in window)) { plan(); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { io.disconnect(); plan(); } });
      }, { threshold: 0.35 });
      io.observe(this);
    }
  }
  if (!customElements.get('ds-sfeer-kiezer')) customElements.define('ds-sfeer-kiezer', DsSfeerKiezer);
})();

